"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const components_1 = require("components");
function TransactionStatusPillButton({ status, onClick = () => { }, displayOnly = false, }) {
    return ((0, jsx_runtime_1.jsxs)("div", { className: `pill-button ${displayOnly ? ' display-only' : ''}`, "data-testid": "transaction-status-pill-button", onClick: onClick, role: "button", tabIndex: 0, onKeyDown: (e) => {
            if (e.key === 'Enter') {
                onClick();
            }
        }, children: [(0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)({
                    indicator: true,
                    signed: status === 'Signed',
                    pending: status === 'Pending Signature',
                }) }), (0, jsx_runtime_1.jsx)(components_1.P, { variant: "body-small", children: status })] }));
}
exports.default = TransactionStatusPillButton;
